module.exports = __webpack_public_path__ + "img/create-treatment-button-en.593cdf0a.png";